export const camel2title = (camelCase: string) =>
  camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();

export const replaceTemplateSyntax = (
  htmlString?: string,
  data?: Record<string, string>
): string | undefined => {
  /**
   * Replaces HTML template syntax like {{test}} in an HTML string with corresponding values from the data object.
   *
   * @param htmlString - The HTML string containing template syntax.
   * @param data - An object containing key-value pairs for replacing the template syntax.
   * @returns The modified HTML string with replaced template syntax.
   */

  try {
    // Check if the htmlString is a valid string
    if (typeof htmlString !== 'string') {
      throw new TypeError('htmlString must be a string');
    }

    // Check if the data is a valid object
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
      throw new TypeError('data must be a non-null object');
    }

    // Replace template syntax with corresponding values
    let modifiedHtmlString = htmlString;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        const regex = new RegExp(`{{${key}}}`, 'g');
        modifiedHtmlString = modifiedHtmlString.replace(regex, value);
      }
    }

    return modifiedHtmlString;
  } catch (error) {
    // Log the error
    console.error('Error:', error);
    return htmlString; //can be undefined
  }
};

export const getTextFromHtml = (html: string) => {
  var divContainer = document.createElement('div');
  divContainer.innerHTML = html;
  return divContainer.textContent || divContainer.innerText || '';
};

export const insertWordBreaks = (text?: string) => {
  return text?.replace(/ /g, ' <wbr>').replace(/\//g, '/<wbr>') || '';
};
